<script>
  import { copyToClipboard } from "../helper";
  import SectionNumber from "../components/SectionNumber.svelte";
  import TextReveal from "../components/TextReveal.svelte";
  import axios from "axios";

  function sendEmail() {
    const emailAddress = "shxdowmusic281@gmail.com";
    copyToClipboard(emailAddress);
  }

  function openInstagram() {
    const instagramUrl = "https://www.instagram.com/shxdowmusic/";
    window.open(instagramUrl, "_blank");
  }
</script>

<section
  id="contact"
  class="main overflow-hidden relative bg-gray-100 bg-gradient-to-b dark:from-gray-800 dark:to-gray-900"
>
  <div
    data-aos="slide-down"
    data-aos-delay="900"
    data-aos-duration="700"
    class="absolute background right-0 w-2/5 h-full moving-gradient-1"
  />

  <SectionNumber
    left
    number="let's connect"
    shaftClasses="bg-gray-700 dark:bg-gray-50"
    textClasses="text-gray-700 dark:text-gray-50"
  />

  <section class="section relative">
    <div
      class="bg-gray-50 dark:bg-gray-900 shadow-2xl px-5 md:px-7 py-10 lg:px-10 lg:py-14 mb-16"
    >
      <div>
        <div
          data-aos="flip-up"
          data-aos-delay="600"
          data-aos-duration="700"
          class="bg-purple-400 dark:bg-purple-300 shadow-purple-300/60 shadow-lg w-8 h-1.5 lg:w-10 lg:h-2 ml-0.5 mb-6"
        />
      </div>
      <div class="lg:flex gap-10">
        <div class="basis-2/5">
          <h2
            class="text-gray-700 dark:text-gray-200 inline-block tracking-wide text-4xl md:text-5xl lg:text-6xl font-black mb-2"
          >
            <TextReveal text="CONTACT ME" />
          </h2>

          <h5 data-aos="fade" class="text-gray-500 dark:text-gray-300 mb-7">
            Interested in ghost production, mixing, mastering, or just want to say hi? Feel free to reach out to me via email <u><b>shxdowmusic281@gmail.com</b></u> or Instagram <u><b><a href="https://www.instagram.com/shxdowmusic/">@shxdowmusic</a></b></u>!
          </h5>
          

          <!-- Button to email -->
          <button
            type="button"
            class="transition-colors bg-purple-200 shadow-purple-300/20 shadow-lg rounded-sm border border-purple-400 hover:bg-purple-300 text-gray-700 py-1 px-4 flex items-center gap-3"
            on:click={sendEmail}
          >
            <i class="far fa-envelope text-xs"></i>
            <p class="font-semibold font-mono">Email me</p>
          </button>

          <!-- Button to Instagram -->
          <button
            type="button"
            class="transition-colors bg-purple-200 shadow-purple-300/20 shadow-lg rounded-sm border border-purple-400 hover:bg-purple-300 text-gray-700 py-1 px-4 flex items-center gap-3 mt-3"
            on:click={openInstagram}
          >
            <i class="fab fa-instagram text-xs"></i>
            <p class="font-semibold font-mono">Instagram</p>
          </button>
        </div>
      </div>
    </div>
  </section>

  <button
    title="Back to top"
    aria-label="Back to top"
    data-aos="fade-up"
    data-aos-offset="200"
    data-aos-duration="700"
    on:click={() => window.scrollTo(0, 0)}
    class="group text-xl lg:text-3xl py-5 text-gray-700 dark:text-white w-14 mx-auto text-center absolute bottom-20 right-0 left-0"
  >
    <i class="hover-vertical fas fa-angle-up group-hover:pause" />
  </button>
</section>

<style>
</style>
